<!--  -->
<template>
    <div class='card_wrapper box box_v'  ref="left4">
        <div class="title">网格化管理</div>
         <div class="tr box">
                <div class="td1 box_f1">街/乡</div>
                <div class="td2 ">网格长</div>
                <div class="td2">楼院长</div>
                <div class="td2">楼栋长</div>
                <div class="td2" style="margin-right:20px">单元长</div>
            </div>
            <scroll :style="{'height':height}">
                <div  
                v-for="(item,index) in list" :key="item.communityId"
                :class="{'active':index==selectIndex}"
                class="tr_item box_f1 box"
                @click="selectGrid(index)">
                    <div class="td1 box_f1">{{item.communityName}}</div>
                    <div class="td2 ">{{item.gridCount}}</div>
                    <div class="td2">{{item.courtyardUserCount}}</div>
                    <div class="td2">{{item.buildingUserCount}}</div>
                    <div class="td2"  style="margin-right:20px">{{item.unitUserCount}}</div>
                </div>
            </scroll>
    </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import scroll from './scroll'
export default {
    //import引入的组件需要注入到对象中才能使用
    components: {scroll},
    data() {
    //这里存放数据
        return {
            list:[],
            height:'100%',
            selectIndex:-1
        };
    },
    props:{
        initStatus:{
            default:true,
            type:Boolean
        }
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {
        initStatus(newVal){
            if(newVal) this.selectIndex=-1
        }
    },
    //方法集合
    methods: {
        getData(){
            this.$get(this.urlobj.xf_grid).then(res=>{
               this.list = res.rows
            })
        },
        selectGrid(index){
            this.selectIndex = index
            if(this.list[index].gridCount && this.list[index].gridList.length){
                this.$emit('selectGrid',this.list[index].gridList)
            }else{
                this.$Message.info('暂无网格')
            }
        }
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
         this.$nextTick(()=>{
            this.height = this.$refs.left4.offsetHeight-115 + 'px'
            this.getData()
        })
    },
    beforeCreate() {}, //生命周期 - 创建之前
    beforeMount() {}, //生命周期 - 挂载之前
    beforeUpdate() {}, //生命周期 - 更新之前
    updated() {}, //生命周期 - 更新之后
    beforeDestroy() {}, //生命周期 - 销毁之前
    destroyed() {}, //生命周期 - 销毁完成
    activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
    }
</script>
<style lang='less' scoped>
//@import url(); 引入公共css类
.card_wrapper{
    width: 100%;
    height:100%;
    background-image: url('../../../assets/images/monitorctxf/leftbottom.png');
    background-size: 100% 100%;
    //overflow-y: scroll;
    .title{
        margin:20px 0 20px 20px;
        color:#fff;
        font-size: 18px;
        font-weight: bold
    }
   .tr{
        color:#FFEE9D;
        margin:0 10px 10px 10px;
        height: 38px;
        line-height:38px;
        background: linear-gradient(90deg, rgba(67, 96, 71, 0) 0%, rgba(255, 201, 148, 0.5) 48%, rgba(67, 96, 71, 0) 100%);
    }
    .td1{
        text-align: center;
    }
    .td2{
        width:60px;
        text-align: center;
    }
    .td3{
        width:60px;
        text-align: center;
    }
    .td4{
        width:60px;
    }
    .tr_item{
        line-height: 36px;
        margin:0 10px;
        .td1{
            color:#fff;
        }
        .td2{
            font-size: 14px;
            font-family: Digital dream Fat;
            font-style: italic;
            font-weight:bold;
            color: #0EFCFF;

            background: linear-gradient(180deg, #FFF1D9 0%, #24DEEA 100%);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
        }
    }
    .active{
        background: linear-gradient(90deg, rgba(255, 246, 0, 0.2) 0%, rgba(116, 10, 0, 0.5) 100%);
    }
}
</style>